import { render, staticRenderFns } from "./real-video.vue?vue&type=template&id=371f4784&scoped=true&"
import script from "./real-video.vue?vue&type=script&lang=ts&"
export * from "./real-video.vue?vue&type=script&lang=ts&"
import style0 from "./real-video.vue?vue&type=style&index=0&id=371f4784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f4784",
  null
  
)

export default component.exports